export default __webpack_public_path__ + "static/media/vipbg.4b558559.png";